module.exports = __webpack_public_path__ + "img/1.0ee972a6.jpg";